import { Converter } from '../types/converter';

export const velocityAngularConverter: Converter = {
  id: 'velocityAngular',
  name: 'Angular Velocity Converter',
  icon: 'RotateCw',
  categories: ['engineering', 'physics'],
  units: [
    // Base unit
    { name: 'Radian/second', symbol: 'rad/s', factor: 1 },
    { name: 'Radian/day', symbol: 'rad/d', factor: 1/86400 },
    { name: 'Radian/hour', symbol: 'rad/h', factor: 1/3600 },
    { name: 'Radian/minute', symbol: 'rad/min', factor: 1/60 },
    
    // Degree-based units
    { name: 'Degree/day', symbol: '°/d', factor: 0.000000302831 },      // (π/180)/86400
    { name: 'Degree/hour', symbol: '°/h', factor: 0.00000726794 },      // (π/180)/3600
    { name: 'Degree/minute', symbol: '°/min', factor: 0.000436332 },    // (π/180)/60
    { name: 'Degree/second', symbol: '°/s', factor: 0.0174533 },        // π/180
    
    // Revolution-based units
    { name: 'Revolution/day', symbol: 'r/d', factor: 0.0000727221 },    // 2π/86400
    { name: 'Revolution/hour', symbol: 'r/h', factor: 0.00174533 },     // 2π/3600
    { name: 'Revolution/minute', symbol: 'r/min', factor: 0.104720 },   // 2π/60
    { name: 'Revolution/second', symbol: 'r/s', factor: 6.28318531 }    // 2π
  ]
};
